import {
    REQUEST_ENUMS,
    RECEIVE_ENUMS,
    RELOAD_ENUMS,
    ERROR_ENUMS
} from '../types'
import {initialEnumItemFetchState} from "../../constants/defaultValues"
import _get from "lodash/get"
import _cloneDeep from 'lodash/cloneDeep'
import {loadDataRefresh} from "../../constants/constants";

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_ENUMS:
            newState[action.identifier] = {
                ...initialEnumItemFetchState,
                data: _get(newState, [action.identifier, 'data'], {}),
                isFetching: true
            }
            return newState
        case RECEIVE_ENUMS:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: action.payload,
                shouldReload: false,
                message: '',
                validUntil: loadDataRefresh.shortestest + Date.now(),
                errors: {}
            }
            return newState
        case RELOAD_ENUMS:
            if(newState[action.identifier]){
                newState[action.identifier] = {
                    ...newState[action.identifier],
                    shouldReload: true,
                }
            }
            return newState
        case ERROR_ENUMS:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: {},
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}